import { FC, ReactNode } from 'react'
import useFilter from '@components/Items/utils/hooks/useFilter'
import { QUERY_KEYS } from '@components/Items/utils/functions'
import _isEmpty from 'lodash/isEmpty'
import Checkbox from '@components/Items/components/checkbox'

const Category2: FC<{
  children: ReactNode
  category1: string
  category2: string
}> = ({ category1, category2, children }) => {
  const { categoryJsonQuery = {}, updateQuery } = useFilter()
  const isChecked = (categoryJsonQuery[category1] || []).includes(category2)

  const handleChange = async () => {
    if (isChecked) {
      const index = categoryJsonQuery[category1].indexOf(category2)
      categoryJsonQuery[category1].splice(index, 1)
      if (categoryJsonQuery[category1].length === 0) {
        delete categoryJsonQuery[category1]
      }
    } else {
      categoryJsonQuery[category1]
        ? categoryJsonQuery[category1].push(category2)
        : (categoryJsonQuery[category1] = [category2])
    }

    updateQuery(
      QUERY_KEYS.CATEGORIES,
      encodeURIComponent(
        !_isEmpty(categoryJsonQuery) ? JSON.stringify(categoryJsonQuery) : ''
      )
    )
  }

  return (
    <Checkbox onChange={handleChange} checked={isChecked}>
      {children}
    </Checkbox>
  )
}

export default Category2
